<template>
  <div v-html="processTheNote(note)"></div>
  <!-- <span v-if="note.readMore">
      <v-dialog max-width="600">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn
            v-bind="activatorProps"
            color="#5865f2"
            text="Read More"
            variant="flat"
            slim
            size="x-small"
          ></v-btn>
        </template>

        <template v-slot:default="{ isActive }">
          <v-card>
            <v-card-title
              >{{ customer.firstname }} {{ customer.lastname }}</v-card-title
            >
            <v-card-subtitle
              >{{ customer.email }}
              {{ customer.phone }}
            </v-card-subtitle>

            <v-card-text>
              <div>
                <v-chip
                  v-for="service in getServicesForIds(
                    note.salon_appointment_service_id
                  )"
                  :key="service.id"
                  size="small"
                  :class="`bg-${getTitleColor(service)}`"
                >
                  {{ service.description }}
                </v-chip>
              </div>
              <v-divider></v-divider>
              {{ note.client_note }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                text="Close Dialog"
                @click="isActive.value = false"
              ></v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </span> -->
</template>

<script>
export default {
  name: "NoteText",
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const apiURL = import.meta.env.VITE_API_URL;
    return { apiURL };
  },
  methods: {
    processTheNote(note) {
      let text = note.client_note;
      if (typeof text === "string" && text.length > 150) {
        note.readMore = true;
        return this.nl2br(text.substring(0, 150));
      }
      return this.nl2br(text);
    },
    nl2br(text) {
      if (typeof text !== "string") return text;
      return text.replace(/\n/g, '<br>');
    },
  },
};
</script>
